import appConfig from 'src/utils/appConfig';

export default (config, parsedNodes) => {
  appConfig.setParsedNodes(parsedNodes);
  appConfig.setFlowId(config.flowId);
  appConfig.setFlowVersion(config.version);
  appConfig.setLearningLanguage(config.learningLanguage);
};
